import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

export function Brand({ className = "", size = "md" }) {
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <span className={`font-heading font-black uppercase tracking-tight ${text} text-white leading-none ${className}`} data-testid="brand-logo">
      ZA<span className="text-[#CCFF00]">!</span>RUNNER<span className="text-[#CCFF00]">ZZ</span>
    </span>
  );
}

export function StaffBadge() {
  return (
    <Link
      to="/login"
      data-testid="staff-login-link"
      className="flex h-9 w-9 items-center justify-center rounded-full border border-[#CCFF00]/40 bg-black/40 text-[#CCFF00] transition-colors hover:bg-[#CCFF00]/10"
      title="Staff sign in"
    >
      <Shield className="h-4 w-4" />
    </Link>
  );
}
